/* AMO Theme JS */
(function(){
  'use strict';

  var FREE_SHIP_THRESHOLD = 0; // Free shipping on all orders

  // MOBILE NAV
  var menuOpen = document.getElementById('menu-open');
  var menuClose = document.getElementById('menu-close');
  var mobileNav = document.getElementById('mobile-nav');
  if(menuOpen && mobileNav){
    menuOpen.addEventListener('click',function(){ mobileNav.classList.add('open'); document.body.style.overflow='hidden'; });
  }
  if(menuClose && mobileNav){
    menuClose.addEventListener('click',function(){ mobileNav.classList.remove('open'); document.body.style.overflow=''; });
  }
  if(mobileNav){
    mobileNav.addEventListener('click',function(e){ if(e.target===mobileNav){ mobileNav.classList.remove('open'); document.body.style.overflow=''; } });
  }

  // CART DRAWER
  var cartOpen = document.getElementById('cart-open');
  var cartClose = document.getElementById('cart-close');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartContinue = document.getElementById('cart-continue');

  function openCart(){ if(cartOverlay){ cartOverlay.classList.add('open'); document.body.style.overflow='hidden'; fetchCart(); } }
  function closeCart(){ if(cartOverlay){ cartOverlay.classList.remove('open'); document.body.style.overflow=''; } }

  if(cartOpen) cartOpen.addEventListener('click', openCart);
  if(cartClose) cartClose.addEventListener('click', closeCart);
  if(cartContinue) cartContinue.addEventListener('click', closeCart);
  if(cartOverlay) cartOverlay.addEventListener('click',function(e){ if(e.target===cartOverlay) closeCart(); });

  function fetchCart(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); }).catch(function(e){ console.error(e); });
  }

  function renderCart(cart){
    var count = cart.item_count;

    // Update navbar badge
    var badge = document.getElementById('cart-count');
    if(badge) badge.textContent = count;

    // Update drawer header count
    var hdCount = document.getElementById('cart-hd-count');
    if(hdCount) hdCount.textContent = count > 0 ? ' (' + count + ')' : '';

    var empty  = document.getElementById('cart-empty');
    var items  = document.getElementById('cart-items');
    var footer = document.getElementById('cart-footer');
    var total  = document.getElementById('cart-total');
    var fs     = document.getElementById('cart-free-ship');
    var up     = document.getElementById('cart-upsell');

    if(!items) return;

    if(count === 0){
      if(empty)  empty.style.display  = 'flex';
      if(footer) footer.style.display = 'none';
      if(fs)     fs.style.display     = 'none';
      if(up)     up.style.display     = 'none';
      items.innerHTML = '';
      return;
    }

    if(empty)  empty.style.display  = 'none';
    if(footer) footer.style.display = 'block';
    if(total)  total.textContent    = formatMoney(cart.total_price);

    renderAOVBar(cart);
    renderUpsell(cart);

    items.innerHTML = cart.items.map(function(item, i){
      var line = i + 1;
      return '<div class="cart-item">' +
        '<div class="cart-item-img"><img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></div>' +
        '<div class="cart-item-info">' +
          '<p class="cart-item-name">' + escapeHtml(item.product_title) + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
          '<div class="cart-item-row">' +
            '<div class="cart-qty-wrap">' +
              '<button class="cart-qty-btn" onclick="AMO.changeQty(' + line + ',' + (item.quantity - 1) + ')">−</button>' +
              '<span class="cart-qty-num">' + item.quantity + '</span>' +
              '<button class="cart-qty-btn" onclick="AMO.changeQty(' + line + ',' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
            '<p class="cart-item-price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
        '</div>' +
        '<button class="cart-remove" onclick="AMO.changeQty(' + line + ',0)" aria-label="Remove">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
        '</button>' +
      '</div>';
    }).join('');
  }

  // ── CART AOV SPEND-TIER BAR ──────────────────────────────────────
  function renderAOVBar(cart){
    var el   = document.getElementById('cart-aov-bar');
    var msg  = document.getElementById('cart-aov-msg');
    var fill = document.getElementById('cart-aov-fill');
    if(!el || !msg || !fill) return;

    var total = cart.total_price; // in cents
    var TIER1 = 5000;   // $50
    var TIER2 = 7500;   // $75

    el.style.display = 'block';

    if(total >= TIER2){
      var pct = 100;
      fill.style.width = '100%';
      fill.classList.add('done');
      msg.innerHTML = '🌺 <strong>Full AMO haul unlocked!</strong> Mahalo for your island order — enjoy free shipping + our aloha promise.';
    } else if(total >= TIER1){
      var need = formatMoney(TIER2 - total);
      var pct  = Math.round((total / TIER2) * 100);
      fill.classList.remove('done');
      fill.style.width = pct + '%';
      msg.innerHTML = '🌟 Almost VIP! Add <em>' + need + '</em> more to hit our top-tier $75 AMO Family order.';
    } else {
      var need = formatMoney(TIER1 - total);
      var pct  = Math.round((total / TIER1) * 100);
      fill.classList.remove('done');
      fill.style.width = pct + '%';
      msg.innerHTML = '🚀 Add <em>' + need + '</em> more to hit the $50 AMO Family tier and unlock VIP savings.';
    }
  }

  // ── UPSELL / ONO ADD-ONS ─────────────────────────────────────────
  var _upsellProductId = null;

  function renderUpsell(cart){
    var el   = document.getElementById('cart-upsell');
    var list = document.getElementById('cart-upsell-list');
    if(!el || !list || cart.items.length === 0){ if(el) el.style.display = 'none'; return; }

    var firstId = cart.items[0].product_id;
    if(firstId === _upsellProductId) return; // already loaded
    _upsellProductId = firstId;

    var inCart = cart.items.map(function(i){ return i.product_id; });

    fetch('/recommendations/products.json?product_id=' + firstId + '&limit=6&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var recs = (data.products || []).filter(function(p){
          return inCart.indexOf(p.id) === -1;
        }).slice(0, 3);

        if(recs.length === 0){ el.style.display = 'none'; return; }

        el.style.display = 'block';
        list.innerHTML = recs.map(function(p){
          var v   = p.variants[0];
          var img = p.featured_image || '';
          return '<div class="cart-upsell-item">' +
            '<div class="cart-upsell-img">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</div>' +
            '<div class="cart-upsell-info">' +
              '<p class="cart-upsell-name">' + escapeHtml(p.title) + '</p>' +
              '<p class="cart-upsell-price">' + formatMoney(v.price) + '</p>' +
            '</div>' +
            '<button class="cart-upsell-add" onclick="AMO.upsellAdd(' + v.id + ',\'' + escapeHtml(p.title).replace(/'/g,"\\'") + '\',this)">+ Add</button>' +
          '</div>';
        }).join('');
      })
      .catch(function(){ el.style.display = 'none'; });
  }

  // ── HELPERS ──────────────────────────────────────────────────────
  function formatMoney(cents){
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str){
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  // ── TOAST ────────────────────────────────────────────────────────
  function showToast(msg){
    var toast    = document.getElementById('toast');
    var toastMsg = document.getElementById('toast-msg');
    if(!toast) return;
    if(toastMsg) toastMsg.textContent = msg;
    toast.classList.add('show');
    setTimeout(function(){ toast.classList.remove('show'); }, 2800);
  }

  // ── QUICK ADD TO CART ────────────────────────────────────────────
  document.addEventListener('click',function(e){
    var btn = e.target.closest('.quick-add');
    if(!btn) return;
    e.preventDefault();
    var id    = btn.dataset.id;
    var title = btn.dataset.title || 'Item';
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:id,quantity:1})
    }).then(function(r){ return r.json(); }).then(function(){
      btn.textContent = '✓ Added';
      showToast(title + ' added to cart 🌺');
      fetchCart();
      setTimeout(function(){ btn.disabled=false; btn.textContent='Add to Cart'; },2000);
    }).catch(function(){
      btn.disabled=false;
      btn.textContent='Add to Cart';
    });
  });

  // ── PRODUCT FORM ─────────────────────────────────────────────────
  var productForm = document.getElementById('product-form');
  if(productForm){
    productForm.addEventListener('submit',function(e){
      e.preventDefault();
      var btn = document.getElementById('add-to-cart');
      var id  = document.getElementById('variant-input');
      if(!id || !btn) return;
      btn.disabled = true;
      var orig = btn.innerHTML;
      btn.innerHTML = 'Adding...';
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:parseInt(id.value),quantity:1})
      }).then(function(r){ return r.json(); }).then(function(item){
        showToast((item.product_title||'Item') + ' added to cart 🌺');
        fetchCart();
        openCart();
        btn.innerHTML = '✓ Added';
        setTimeout(function(){ btn.disabled=false; btn.innerHTML=orig; },2200);
      }).catch(function(){
        btn.disabled=false;
        btn.innerHTML=orig;
      });
    });
  }

  // ── PREDICTIVE SEARCH ────────────────────────────────────────────
  var _srchOverlay = document.getElementById('search-overlay');
  var _srchInput   = document.getElementById('search-input');
  var _srchClose   = document.getElementById('search-close');
  var _srchOpen    = document.getElementById('search-open');
  var _srchResults = document.getElementById('search-results');
  var _srchTimer   = null;
  var _srchLastQ   = '';

  function openSearch(){
    if(!_srchOverlay) return;
    _srchOverlay.classList.add('is-open');
    _srchOverlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ if(_srchInput) _srchInput.focus(); }, 60);
  }

  function closeSearch(){
    if(!_srchOverlay) return;
    _srchOverlay.classList.remove('is-open');
    _srchOverlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    if(_srchInput) _srchInput.value = '';
    if(_srchResults) _srchResults.innerHTML = '';
    _srchLastQ = '';
  }

  if(_srchOpen)  _srchOpen.addEventListener('click', openSearch);
  if(_srchClose) _srchClose.addEventListener('click', closeSearch);
  if(_srchOverlay){
    _srchOverlay.addEventListener('click', function(e){
      if(e.target === _srchOverlay || e.target.classList.contains('search-overlay-backdrop')) closeSearch();
    });
  }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && _srchOverlay && _srchOverlay.classList.contains('is-open')){
      closeSearch();
    }
    if(e.key === '/' && !['INPUT','TEXTAREA','SELECT'].includes(document.activeElement.tagName)){
      e.preventDefault();
      openSearch();
    }
  });
  if(_srchInput){
    _srchInput.addEventListener('input', function(){
      var q = _srchInput.value.trim();
      clearTimeout(_srchTimer);
      if(q.length < 2){ if(_srchResults) _srchResults.innerHTML = ''; _srchLastQ = ''; return; }
      if(q === _srchLastQ) return;
      if(_srchResults) _srchResults.innerHTML = '<p class="search-loading">Searching…</p>';
      _srchTimer = setTimeout(function(){ runSearch(q); }, 280);
    });
  }

  function runSearch(q){
    _srchLastQ = q;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(q !== _srchLastQ || !_srchResults) return;
        var products = ((data.resources || {}).results || {}).products || [];
        renderSearchResults(products, q);
      })
      .catch(function(){
        if(_srchResults) _srchResults.innerHTML = '<p class="search-no-results">Could not load results. <a href="/search?q=' + encodeURIComponent(q) + '">Try full search →</a></p>';
      });
  }

  function renderSearchResults(products, q){
    if(!_srchResults) return;
    if(!products.length){
      _srchResults.innerHTML = '<p class="search-no-results">No products found for “<strong>' + escapeHtml(q) + '</strong>”</p>';
      return;
    }
    var html = '<span class="search-results-label">Products (' + products.length + ')</span><div class="search-results-grid">';
    products.forEach(function(p){
      var img   = p.featured_image ? '<img src="' + p.featured_image.url + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '';
      var price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
      html += '<a href="' + p.url + '" class="search-result-item">';
      html += '<div class="search-result-img">' + img + '</div>';
      html += '<div class="search-result-body"><p class="search-result-name">' + escapeHtml(p.title) + '</p>';
      if(price) html += '<p class="search-result-price">' + price + '</p>';
      html += '</div></a>';
    });
    html += '</div>';
    html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-view-all">View all results for “' + escapeHtml(q) + '” →</a>';
    _srchResults.innerHTML = html;
  }

  // ── DROPDOWN ACCESSIBILITY ────────────────────────────────────────
  document.querySelectorAll('.has-dropdown').forEach(function(el){
    var toggle = el.querySelector(':scope > a');
    if(!toggle) return;

    toggle.addEventListener('click', function(e){
      e.preventDefault();
      var nowOpen = el.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
    });

    el.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        el.classList.remove('is-open');
        toggle.setAttribute('aria-expanded','false');
        toggle.focus();
      }
    });
  });

  document.addEventListener('click', function(e){
    if(!e.target.closest('.has-dropdown')){
      document.querySelectorAll('.has-dropdown.is-open').forEach(function(el){
        el.classList.remove('is-open');
        var t = el.querySelector(':scope > a');
        if(t) t.setAttribute('aria-expanded','false');
      });
    }
  });

  // ── SMART STICKY HEADER ─────────────────────────────────────────
  (function(){
    var hdr = document.querySelector('.site-header');
    if(!hdr) return;
    var lastY = 0, ticking = false;
    function update(){
      var y = window.scrollY;
      if(y < 80){
        hdr.classList.remove('hdr-hidden');
      } else if(y > lastY + 8){
        hdr.classList.add('hdr-hidden');
      } else if(y < lastY - 4){
        hdr.classList.remove('hdr-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  })();

  // ── BACK TO TOP ──────────────────────────────────────────────────
  (function(){
    var btn = document.getElementById('back-to-top');
    if(!btn) return;
    window.addEventListener('scroll', function(){
      btn.classList.toggle('is-visible', window.scrollY > 420);
    }, { passive: true });
    btn.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  // ── WISHLIST — COLLECTION CARD HEARTS ───────────────────────────
  var _WL_KEY      = 'amo_wishlist_v1';
  var _WL_DATA_KEY = 'amo_wishlist_data_v1';

  function _getWL(){ try{ return JSON.parse(localStorage.getItem(_WL_KEY)||'[]'); }catch(e){ return []; } }
  function _saveWL(wl){ try{ localStorage.setItem(_WL_KEY, JSON.stringify(wl)); }catch(e){} }
  function _setWLBtn(btn, wished){
    btn.classList.toggle('is-wished', wished);
    btn.setAttribute('aria-label', wished ? 'Remove from wishlist' : 'Save to wishlist');
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.col-card-wishlist');
    if(!btn) return;
    var handle = btn.dataset.handle;
    if(!handle) return;
    var wl  = _getWL();
    var idx = wl.indexOf(handle);
    if(idx > -1){
      wl.splice(idx, 1);
    } else {
      wl.push(handle);
      try{
        var data = JSON.parse(localStorage.getItem(_WL_DATA_KEY)||'{}');
        data[handle] = {handle:handle, title:btn.dataset.title, img:btn.dataset.img, price:btn.dataset.price, url:btn.dataset.url};
        localStorage.setItem(_WL_DATA_KEY, JSON.stringify(data));
      }catch(err){}
    }
    _saveWL(wl);
    _setWLBtn(btn, wl.indexOf(handle) > -1);
  });

  (function(){
    var wl = _getWL();
    document.querySelectorAll('.col-card-wishlist').forEach(function(btn){
      _setWLBtn(btn, wl.indexOf(btn.dataset.handle) > -1);
    });
  })();

  // ── GIFT MESSAGE — CART DRAWER ───────────────────────────────────
  (function(){
    var toggle = document.getElementById('gift-msg-toggle');
    var body   = document.getElementById('gift-msg-body');
    var input  = document.getElementById('gift-msg-input');
    var save   = document.getElementById('gift-msg-save');
    if(!toggle || !body || !input || !save) return;

    toggle.addEventListener('click', function(){
      var isOpen = body.style.display !== 'none';
      body.style.display = isOpen ? 'none' : 'block';
      toggle.classList.toggle('is-open', !isOpen);
    });

    try{ var saved = localStorage.getItem('amo_gift_msg_v1'); if(saved) input.value = saved; }catch(e){}

    save.addEventListener('click', function(){
      var msg = input.value.trim();
      try{ localStorage.setItem('amo_gift_msg_v1', msg); }catch(e){}
      fetch('/cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:{'Gift Message': msg}})
      }).then(function(){
        save.textContent = '✓ Saved!';
        setTimeout(function(){ save.textContent = 'Save Message'; }, 2000);
      }).catch(function(){});
    });
  })();

  // ── SOCIAL PROOF REVIEW TOAST ────────────────────────────────────
  (function(){
    var el = document.getElementById('review-toast');
    if(!el) return;
    var reviews = [
      {name:'Sarah K.',     loc:'Honolulu, HI',   text:'Best Kona coffee I\'ve ever had shipped to me. My family is absolutely obsessed — AMO is our go-to Hawaiian store!'},
      {name:'Marcus K.',    loc:'San Diego, CA',   text:'Grew up in Maui and AMO is the only place I find my childhood favorites on the mainland. Top quality, always.'},
      {name:'Lisa T.',      loc:'Austin, TX',      text:'Ordered as a gift for my husband — he was moved to tears. Beautiful packaging and everything arrived perfectly fresh.'},
      {name:'James P.',     loc:'Fort Bragg, NC',  text:'Ships to APO addresses! As a deployed service member, getting authentic Hawaiian goods is a massive morale boost.'},
      {name:'Keiko R.',     loc:'Portland, OR',    text:'The li hing mui candy is SO good. My entire office is now addicted. Lightning-fast shipping too!'},
      {name:'Dave M.',      loc:'New York, NY',    text:'Same brands I bought at ABC Stores in Maui. Took a chance and it paid off — 100% the real thing.'},
      {name:'Tasha L.',     loc:'Atlanta, GA',     text:'The Hawaiian Sun drinks are incredible. My family goes through cases every month. Never going back to regular juice.'},
      {name:'Robert C.',    loc:'Seattle, WA',     text:'First order arrived in 3 days and everything was fresh. Customer service is outstanding. Highly recommend!'}
    ];
    var nameEl  = el.querySelector('.rt-name');
    var locEl   = el.querySelector('.rt-loc');
    var txtEl   = el.querySelector('.rt-text');
    var closeEl = el.querySelector('.rt-close');
    if(!nameEl || !locEl || !txtEl) return;
    var idx = 0;
    function showReview(){
      var r = reviews[idx % reviews.length]; idx++;
      nameEl.textContent = r.name;
      locEl.textContent  = r.loc;
      txtEl.textContent  = '“' + r.text + '”';
      el.classList.add('is-visible');
      setTimeout(function(){ el.classList.remove('is-visible'); }, 7000);
    }
    setTimeout(showReview, 14000);
    setInterval(showReview, 38000);
    if(closeEl) closeEl.addEventListener('click', function(){ el.classList.remove('is-visible'); });
  })();

  // ── PUBLIC API ───────────────────────────────────────────────────
  window.AMO = {
    changeQty: function(line, qty){
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({line:line,quantity:qty})
      }).then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); });
    },
    upsellAdd: function(variantId, title, btn){
      if(btn){ btn.disabled=true; btn.textContent='Adding...'; }
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:variantId,quantity:1})
      }).then(function(r){ return r.json(); }).then(function(){
        showToast((title||'Item') + ' added! 🌺');
        _upsellProductId = null; // reset so upsell refreshes after add
        fetchCart();
        if(btn){ btn.textContent='✓ Added'; setTimeout(function(){ btn.disabled=false; btn.textContent='+ Add'; },2000); }
      }).catch(function(){
        if(btn){ btn.disabled=false; btn.textContent='+ Add'; }
      });
    },
    openCart:   openCart,
    closeCart:  closeCart,
    showToast:  showToast,
    openSearch: openSearch,
    closeSearch: closeSearch
  };

  // Initial cart count on page load
  fetchCart();

})();
